import { forwardRef } from "react";

export function WorldShell({ as: Tag = "main", mode = "operate", className = "", children, ...props }) {
  return (
    <Tag className={`tgc-world-shell tgc-world-shell--${mode} ${className}`.trim()} {...props}>
      {children}
    </Tag>
  );
}

export function WorldFrame({ className = "", children, ...props }) {
  return (
    <div className={`tgc-world-frame ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}

export function WorldWordmark({ as: Tag = "p", className = "", ...props }) {
  return (
    <Tag className={`tgc-world-wordmark ${className}`.trim()} {...props}>
      The Gift Conversation
    </Tag>
  );
}

export const WorldButton = forwardRef(function WorldButton(
  { variant = "primary", className = "", type = "button", ...props },
  ref
) {
  return (
    <button
      ref={ref}
      className={`tgc-world-button tgc-world-button--${variant} ${className}`.trim()}
      type={type}
      {...props}
    />
  );
});
